import {useState} from "react";
import {AnimatePresence, motion} from "framer-motion";


export function genFAQs(){
    let faqs = [
        {
            "question": "What is this website?",
            "answer": "This website is a Duolingo English practice platform where users can engage with over 6,000 types of questions spanning speaking, reading, writing, and listening. The platform provides AI scoring based on parameters similar to the Duolingo English test."
        },
        {
            "question": "How are payments processed?",
            "answer": "Payments are made through the Stripe account and are accepted via PayPal, Google Pay, Apple Pay, and credit cards."
        },
        {
            "question": "What are the subscription options?",
            "answer": "There are three subscription plans: Weekly Plan: $9.99, Monthly Plan: $14.99, 60-Day Plan: $19.99."
        },
        {
            "question": "How long does a subscription last?",
            "answer": "Once a payment is made, the subscription lasts for 7 days, 30 days or 60 days (depending on plan chosen)."
        },
        {
            "question": "Is there a trial period?",
            "answer": "Yes, new users receive 10 free practice questions daily upon sign-up before deciding to become VIP."
        },
        {
            "question": "What if a payment doesn't go through?",
            "answer": "If a payment doesn't go through, users can try again with a different bank card. Alternatively, they can contact customer service at detstudynow@gmail.com"
        },
        {
            "question": "What if the VIP upgrade fails after a successful payment?",
            "answer": "In case of a successful payment but a failed VIP upgrade, users can send a screenshot to the provided email, and the team will respond within 24 hours."
        },
        {
            "question": "Are subscriptions automatically renewed?",
            "answer": "No, none of the packages are automatically renewed. Users have the flexibility to manually renew their subscription before the expiration date."
        },
        {
            "question": "What if the VIP becomes unavailable for use?",
            "answer": "Check the network status, clear your browser cache, and quit. Then, try again. Ensure you are not logged into another account on a different computer, as only one user can be logged in at a time. Check if your VIP subscription has expired."
        },
        {
            "question": "What parameters does the AI algorithm use for scoring?",
            "answer": "The AI scoring is based on Natural Language Processing (NLP) and evaluates Grammatical accuracy, Grammatical complexity, Lexical sophistication, Lexical diversity, Fluency, and Task relevance. Users receive detailed feedback for improvement."
        },
        {
            "question": "Any tips for improving AI scores?",
            "answer": "Speak clearly in a distraction-free environment. Use all available time to answer questions. Longer responses are encouraged, as they may contribute to a better score. Corrections can be made before clicking \"NEXT.\" Avoid frequent timer checks, and leave time to review responses."
        },
        {
            "question": "Is there a troubleshooting guide for technical issues?",
            "answer": "Currently, there isn't a dedicated guide beyond microphone-related questions that have been answered."
        },
        {
            "question": "Do users need to download plugins or software?",
            "answer": "No, there is no need to download any plugins or software for smooth functionality."
        },
        {
            "question": "Can users download or export practice records?",
            "answer": "No, users currently do not have the capability to download or export their practice records for personal reference. The system retains practice records for the most recent month only."
        },
        {
            "question": "Why have my practice records disappeared?",
            "answer": "Practice records are retained for the most recent year. Records older than one year will be automatically deleted to ensure system efficiency and data management. Additionally, users will have the opportunity to listen to other people's recordings as part of the interactive features of the platform."
        },
        {
            "question": "Are there restrictions on sharing practice records?",
            "answer": "Yes, users who are logged in should note that simultaneous access from multiple computers is not allowed. Each user account can be logged in on one computer at a time. Sharing practice records with others is restricted to maintain the integrity of individual user data."
        },
        {
            "question": "How can interested parties discuss collaboration opportunities?",
            "answer": "If you or your institution are interested in exploring collaboration opportunities with us, we welcome you to get in touch! You can initiate the conversation by sending a detailed email outlining your proposal or interests to detstudynow@gmail.com. Our team is eager to engage in discussions that align with our mutual goal of delivering high-quality English training to a broader audience."
        }
    ]




    return faqs
}

export function FAQCard({question, answer}){
    const [showAnswer, setShowAnswer] = useState(false)
    return(

        <div className={`flex flex-col w-full gap-2 px-2 py-2 bg-primary-100 rounded-xl  cursor-pointer ${showAnswer? "shadow-lg":""} `}>
            <div className={"flex flex-row justify-between text-center items-center"}
                 onClick={()=>setShowAnswer(!showAnswer)}
            >
                <span className={"mobile:text-[12px] text-start md:text-[20px] font-bold"}>{question}</span>
                <span className={"text-customBlue text-2xl"}>{showAnswer?"-":"+"}</span>
            </div>
            {
                showAnswer &&
                <AnimatePresence>
                <motion.div
                    style={{overflow: "hidden"}}
                    initial={{height: 0}}
                    animate={{height: "auto"}}
                    transition={{duration: 0.3}}
                    exit={{height: 0}}
                    key={"container"} className={"text-primary-600 text-md"}>{showAnswer?answer:""}</motion.div>
                </AnimatePresence>
            }
        </div>
    )
}

export default function FAQs() {
    const [faqs, setFaqs] = useState(genFAQs())
    return (
        <div id={"faqs"} className={"flex flex-col mobile:p-4 lg:p-20 lg:pt-4"}>

            <div className={"mobile:text-[24px] md:text-[48px] mobile:text-center self-center md:text-left lg:text-5xl font-bold flex flex-row items-center gap-2 leading-normal "}>
                <span >We've got you</span>
                <span className={"text-tertiary-900  "}>Covered</span>
            </div>



            <div className={"grid md:grid-cols-2  md:grid-flow-row gap-4 mt-8 w-full"}>
                {faqs.map((faq, index)=>(
                    <div className={"col-span-1"} key={index}>
                        <FAQCard question={faq.question} answer={faq.answer}/>
                    </div>
                ))}
            </div>







        </div>
    )
}
